<template>
  <section class="instructional-videos">
    <ModalWhatsAppMessage
      :whatsAppMessageId="whatsAppMessageId"
      @load="pagedList"
    >
    </ModalWhatsAppMessage>

    <ModalConfirmAction
      variant='danger'
      refModal='deleteWhatsAppMessage'
      idModal='deleteWhatsAppMessage'
      :loading='loadingDelete'
      :description='descriptionDelete'
      :title='titleDelete'
      @confirmed='deleteWhatsAppMessage'
    ></ModalConfirmAction>

    <ModalConfirmAction
      variant='danger'
      refModal='sendBatchWhatsAppMessage'
      idModal='sendBatchWhatsAppMessage'
      :loading='loadingSendBatch'
      :description='descriptionSendBatch'
      :title='titleSendBatch'
      okText="Enviar"
      @confirmed='sendBatch'
    ></ModalConfirmAction>

    <b-modal
      ref="sendTestWhatsAppMessage"
      id="sendTestWhatsAppMessage"
      title="Enviar mensagem de teste"
      header-bg-variant="info"
      header-text-variant="light"
      @hide="resetSendTest()"
    >
      <section class="modal-font-family">
        <label for="testPhone" class="mb-1">Número de telefone (com DDD)</label>
        <b-form-input
          id="testPhone"
          v-model="testPhone"
          v-mask="'(##) #####-####'"
          placeholder="(11) 91234-5678"
        ></b-form-input>
        <b-form-text>
          A mensagem cadastrada será enviada apenas para este número, para validação.
        </b-form-text>
      </section>

      <template #modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">Cancelar</b-button>
        <b-button variant="success" :disabled="loadingSendTest" @click="sendTest()">
          <b-spinner v-if="loadingSendTest" small></b-spinner>
          <span v-else>Enviar teste</span>
        </b-button>
      </template>
    </b-modal>

    <section class="header d-flex align-items-center justify-content-between">
      <section>
        <p class="m-0 title">
          Listagem completa de todas as mensagens de WhatsApp.
        </p>
      </section>

      <section>
        <button
          class="btn-add-tutorial p-1 px-3"
          @click="showModalWhatsAppMessage()"
        >
          <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M6.66667 0V5.41667C6.66668 5.7274 6.78243 6.02699 6.99135 6.25702C7.20026 6.48704 7.48737 6.631 7.79667 6.66083L7.91667 6.66667H13.3333V15C13.3335 15.4205 13.1747 15.8255 12.8888 16.1338C12.6028 16.4421 12.211 16.631 11.7917 16.6625L11.6667 16.6667H1.66667C1.24619 16.6668 0.841195 16.508 0.532877 16.2221C0.224559 15.9362 0.0357029 15.5443 0.00416685 15.125L8.35567e-08 15V1.66667C-0.000132983 1.24619 0.158672 0.841194 0.444581 0.532877C0.73049 0.224559 1.12237 0.0357028 1.54167 0.00416676L1.66667 0H6.66667ZM6.66667 7.91667C6.46256 7.91669 6.26555 7.99163 6.11302 8.12726C5.96049 8.26289 5.86305 8.44979 5.83917 8.6525L5.83333 8.75V10H4.58333C4.37093 10.0002 4.16664 10.0816 4.01219 10.2274C3.85775 10.3732 3.7648 10.5725 3.75236 10.7845C3.73991 10.9965 3.8089 11.2053 3.94522 11.3682C4.08155 11.5311 4.27492 11.6357 4.48583 11.6608L4.58333 11.6667H5.83333V12.9167C5.83357 13.1291 5.9149 13.3334 6.06071 13.4878C6.20651 13.6423 6.40579 13.7352 6.61783 13.7476C6.82986 13.7601 7.03865 13.6911 7.20153 13.5548C7.3644 13.4185 7.46908 13.2251 7.49417 13.0142L7.5 12.9167V11.6667H8.75C8.9624 11.6664 9.16669 11.5851 9.32114 11.4393C9.47559 11.2935 9.56853 11.0942 9.58098 10.8822C9.59342 10.6701 9.52444 10.4614 9.38811 10.2985C9.25179 10.1356 9.05841 10.0309 8.8475 10.0058L8.75 10H7.5V8.75C7.5 8.52899 7.4122 8.31702 7.25592 8.16074C7.09964 8.00446 6.88768 7.91667 6.66667 7.91667ZM8.33333 0.0358333C8.60282 0.0930414 8.85391 0.216157 9.06417 0.394167L9.16667 0.488333L12.845 4.16667C13.0403 4.36176 13.184 4.60229 13.2633 4.86667L13.2967 5H8.33333V0.0358333Z"
                  fill="#022245" />
          </svg>

          <span class="ml-2">Adicionar mensagem de WhatsApp</span>
        </button>
        <button
          class="btn-add-tutorial p-1 px-3 ml-2"
          @click="exportToExcel()"
        >
          <b-icon icon="file-excel-fill"></b-icon>

          <span class="ml-2">Exportar tags</span>
        </button>
      </section>
    </section>
    <hr />
    <b-container fluid align="and">
      <b-row cols="12">
        <b-col class="m-0 p-0 pr-1 py-1" sm="12" md="12" lg="9" xl="10">
          <b-form-select
            id="triggerTag"
            v-model="whatsAppMessagesMeta.triggerTag"
            :options='tagsWhatsAppMessage'
            value-field='tag'
            text-field='tagDescription'
            @change="pagedList()"
          >
            <template #first>
              <b-form-select-option :value='null' disabled>Selecione a tag de gatilho</b-form-select-option>
            </template>
          </b-form-select>
        </b-col>


        <b-col class="m-0 p-0 pl-1 py-1" sm="12" md="12" lg="3" xl="2">
          <b-button
            variant="success"
            class="w-100 d-flex align-items-center justify-content-center"
            @click="resetFilters()"
          >
            <b-icon icon="arrow-repeat"></b-icon>
            <strong class="ml-2">Limpar filtros</strong>
          </b-button>
        </b-col>
      </b-row>
    </b-container>

    <section class="mt-3">
      <b-overlay
        :show="loading"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="primary"
        class="d-inline-block w-100"
        style="min-height: 100px"
      >
        <table class="w-100 text-center">
          <thead>
          <tr class="thead-tr">
            <th class="py-3 w-33">
              Tag de gatilho
            </th>
            <th class="py-3 w-33">
              Data do cadastro
            </th>
            <th class="py-3 w-33">
              Opções
            </th>
          </tr>
          </thead>
          <tbody>
          <tr
            v-for="(whatsAppMessage, index) in whatsAppMessages"
            :key="`${whatsAppMessage._id}_${index}`"
            class="tbody-tr"
            :style="index < whatsAppMessages.length - 1 ? 'border-bottom: 1px solid #EDEDED;': ''"
          >
            <td class="px-1 py-2">
              {{
                whatsAppMessage.triggerTag
                  ? tagsWhatsAppMessage.find(x => x.tag === whatsAppMessage.triggerTag).tagDescription
                  : 'Nenhuma tag vinculada'
              }}
            </td>

            <td class="px-1 py-2">
              {{ formatDate(whatsAppMessage.createdAt) }}
            </td>

            <td class="px-1 py-2 videoLink">
              <a
                class="mr-3 cursor-pointer"
                @click="showModalEditWhatsAppMessage(whatsAppMessage._id)"
              >
                Editar
              </a>
              <a
                class="cursor-pointer"
                @click="showModaldeleteWhatsAppMessage(whatsAppMessage)"
              >
                Excluir
              </a>
              
              <a
                v-if="whatsAppMessage.phones && whatsAppMessage.phones.length > 0"
                class="cursor-pointer ml-3"
                @click="showModalSendTest(whatsAppMessage)"
              >
                Enviar teste
              </a>
              <a
                v-if="whatsAppMessage.phones && whatsAppMessage.phones.length > 0"
                class="cursor-pointer ml-3"
                @click="showModalSendBatch(whatsAppMessage)"
              >
                Enviar mensagens
              </a>
              <a
                v-if="whatsAppMessage.phones && whatsAppMessage.phones.length > 0"
                class="cursor-pointer ml-3"
                @click="goToLogs(whatsAppMessage._id)"
              >
                Ver logs
              </a>
            </td>
          </tr>
          <tr v-if="(!whatsAppMessages || whatsAppMessages.length === 0) && !loading">
            <td colspan="5" class="text-center">
              <p class="py-2 pt-4"><strong>
                Nenhum vídeo de tutorial encontrado. Tente ajustar os filtros ou adicione um novo vídeo de tutorial
                clicando no botão "Adicionar vídeo de tutorial".
              </strong></p>
            </td>
          </tr>
          </tbody>
        </table>
        <template v-slot:overlay>
          <div class="text-center loading-spinner">
            <b-spinner
              style="width: 3rem; height: 3rem"
              variant="primary"
              label="Large Spinner"
            ></b-spinner>
            <h5 class="text-primary">Buscando...</h5>
          </div>
        </template>

        <section>
          <b-pagination
            v-if='whatsAppMessagesMeta.total > 10'
            align="center"
            :per-page='10'
            v-model="whatsAppMessagesMeta.page"
            :total-rows="whatsAppMessagesMeta.total"
            first-text="⏮"
            prev-text="⏪"
            next-text="⏩"
            last-text="⏭"
            @page-click='setPage'
            size="lg"
            class="mt-3"
          >
          </b-pagination>
        </section>
      </b-overlay>
    </section>
  </section>
</template>
<script>
import ModalWhatsAppMessage from './components/ModalWhatsAppMessage.vue'
import { mapActions } from 'vuex'
import ModalConfirmAction from '@/components/ModalConfirmAction.vue'
import format from 'date-fns/esm/format/index'
import XLSX from 'xlsx'
import { mask } from 'vue-the-mask'

export default {
  name: 'WhatsAppMessages',
  directives: { mask },
  components: { ModalConfirmAction, ModalWhatsAppMessage },
  data() {
    return {
      loadingDelete: false,
      descriptionDelete: '',
      titleDelete: '',
      loadingSendBatch: false,
      descriptionSendBatch: '',
      titleSendBatch: '',
      loadingSendTest: false,
      testPhone: '',
      testWhatsAppMessageId: null,
      loading: false,
      tagsWhatsAppMessage: [],
      whatsAppMessages: [],
      whatsAppMessage: Object,
      whatsAppMessageId: null,
      whatsAppMessagesMeta: {
        triggerTag: null,
        tab: null
      },
      tabs: [
        {
          value: 'Summary',
          tab: 'Seleção de agentes'
        },
        {
          value: 'Insalubrity',
          tab: 'Laudo de Insalubridade'
        },
        {
          value: 'Gro',
          tab: 'GRO'
        },
        {
          value: 'Ltcat',
          tab: 'LTCAT'
        },
        {
          value: 'PreventionistLimits',
          tab: 'Limites Prevencionistas'
        },
        {
          value: 'QuantitativeAssessment',
          tab: 'Avaliação Quantitativa'
        },
        {
          value: 'Pcmso',
          tab: 'PCMSO'
        }
      ]
    }
  },
  async mounted() {
    const { items } = await this.handleTagsInstructionalVideos()
    this.tagsWhatsAppMessage = items.map((x) => {
      return {
        ...x,
        tagDescription: `${x.description} (${x.tag})`
      }
    })
    await this.pagedList()
  },
  methods: {
    ...mapActions('whatsAppMessage', {
      handlePagedList: 'handlePagedList',
      handleDelete: 'handleDelete',
      handleSendInBatch: 'handleSendInBatch',
      handleSendTest: 'handleSendTest',
    }),
    ...mapActions('tags', {
      handleTagsInstructionalVideos: 'handleTagsInstructionalVideos'
    }),
    exportToExcel() {
      const data = this.tagsWhatsAppMessage.map((x) => {
        return {
          Tag: x.tag,
          ['Descrição']: x.description,
          ['Gatilho/Tarefa/Rotina']: x['Gatilho/Tarefa/Rotina']
        }
      })

      const worksheet = XLSX.utils.json_to_sheet(data)
      const workbook = XLSX.utils.book_new()

      XLSX.utils.book_append_sheet(workbook, worksheet, 'Planilha1')
      XLSX.writeFile(workbook, 'tag.xlsx')
    },

    formatDate(date) {
      return format(new Date(date), 'dd/MM/yyyy HH:mm:ss')
    },

    goToLogs(whatsAppMessageId) {
      const query = whatsAppMessageId ? { whatsAppMessage: whatsAppMessageId } : {}
      this.$router.push({ name: 'WhatsAppMessageLogs', query })
    },

    showModalWhatsAppMessage() {
      this.whatsAppMessageId = null
      setTimeout(() => {
        this.$bvModal.show('modalWhatsAppMessage')
      }, 100)
    },

    showModalEditWhatsAppMessage(whatsAppMessageId) {
      this.whatsAppMessageId = whatsAppMessageId
      setTimeout(() => {
        this.$bvModal.show('modalWhatsAppMessage')
      }, 100)
    },

    async setPage(event, page) {
      this.whatsAppMessagesMeta.page = page
      await this.pagedList()
    },

    async pagedList() {
      try {
        this.loading = true
        const { meta, items } = await this.handlePagedList(this.whatsAppMessagesMeta)
        this.whatsAppMessages = items
        this.whatsAppMessagesMeta = meta
        this.loading = false
      } catch (e) {

      }
    },

    async resetFilters() {
      try {
        this.whatsAppMessagesMeta = {
          page: 1,
          limit: 10,
          triggerTag: null,
        }
        await this.pagedList()
      } catch (e) {

      }
    },

    showModaldeleteWhatsAppMessage(whatsAppMessage) {
      this.whatsAppMessage = whatsAppMessage
      this.titleDelete = 'Excluir vídeo de tutorial'
      this.descriptionDelete = 'Tem certeza de que deseja excluir esta mensagem de WhatsApp.?<br/><br/><strong>Essa ação não poderá ser desfeita.</strong>'
      this.$bvModal.show('deleteWhatsAppMessage')
    },

    async deleteWhatsAppMessage() {
      try {
        this.loadingDelete = true

        const { data, status, errors } = await this.handleDelete(this.whatsAppMessage._id)
        let message = errors
        let variant = 'danger'

        if (status === 200 || status === 201) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        await this.pagedList()
        this.$bvModal.hide('deleteWhatsAppMessage')
        this.loadingDelete = false
      } catch (e) {
        this.loadingDelete = false
      }
    },

    showModalSendBatch(whatsAppMessage) {
      this.whatsAppMessage = whatsAppMessage
      this.titleSendBatch = 'Enviar mensagem'
      this.descriptionSendBatch = 'Tem certeza de que deseja enviar a mensagem para todos os números de telefone vinculados?<br/><br/><strong>Essa ação não poderá ser desfeita.</strong>'
      this.$bvModal.show('sendBatchWhatsAppMessage')
    },

    async sendBatch() {
      try {
        this.loadingSendBatch = true
        const {_id} = this.whatsAppMessage || {}
        const { data, status, errors } = await this.handleSendInBatch({ _id })
        let message = errors
        let variant = 'danger'
        const success = status === 200 || status === 201

        if (success) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.$bvModal.hide('sendBatchWhatsAppMessage')
        this.loadingSendBatch = false

        if (success) {
          this.goToLogs(_id)
        }
      } catch (e) {
        this.loadingSendBatch = false
      }
    },

    showModalSendTest(whatsAppMessage) {
      this.testWhatsAppMessageId = whatsAppMessage._id
      this.testPhone = ''
      this.$bvModal.show('sendTestWhatsAppMessage')
    },

    resetSendTest() {
      this.testPhone = ''
      this.testWhatsAppMessageId = null
    },

    async sendTest() {
      try {
        const phone = (this.testPhone || '').replace(/\D/g, '')
        if (phone.length < 10 || phone.length > 11) {
          this.$bvToast.toast('Informe um número de telefone válido com DDD.', {
            title: 'Atenção',
            variant: 'danger',
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000
          })
          return
        }

        this.loadingSendTest = true
        const { data, status, errors } = await this.handleSendTest({
          _id: this.testWhatsAppMessageId,
          phone
        })
        let message = errors
        let variant = 'danger'
        const success = status === 200 || status === 201

        if (success) {
          message = data.message
          variant = 'success'
        }

        this.$bvToast.toast(message, {
          title: 'Atenção',
          variant: variant,
          toaster: 'b-toaster-top-center',
          autoHideDelay: 5000
        })
        this.loadingSendTest = false

        if (success) {
          this.$bvModal.hide('sendTestWhatsAppMessage')
        }
      } catch (e) {
        this.loadingSendTest = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.instructional-videos {
  .header {
    .title {
      font-weight: 700;
      font-size: 16px;
      line-height: 24px;
      color: #262626;
    }

    .btn-add-tutorial {
      font-weight: 400;
      font-size: 15px;
      border: 1px solid #AEBBCD;
      border-radius: 6px;
      color: #6D7989;
      background: #FFFFFF;
    }
  }

  .thead-tr {
    background: var(--navy-blue);
    color: #ECF0F3;
    font-weight: 600;
    font-size: 16px;
    text-align: center;
  }

  .tbody-tr {
    background: #FFFFFF;
    font-size: 15px;
    text-align: center;

    color: #808080;
    font-weight: 400;

    .videoLink {
      font-weight: 700;
      color: var(--navy-blue) !important;
      text-decoration: underline;
    }
  }

  .w-20 {
    width: 20% !important
  }
  .w-33 {
    width: 33.33% !important
  }
}

</style>
